export const ADMIN = 'ADMIN' // 管理员
export const EXPERT = 'EXPERT' // 专家
export const STAFF = 'STAFF' // 现场
